import { Model } from "vue-mc";

export class ParametrosModel extends Model {
  defaults() {
    return {
      clave: 1
      , enableSFTPU: false
      , urlBuzonSFTPU: ""
      , usuarioBuzonSFTPU: ""
      , passwordBuzonSFTPU: ""
      , puertoBuzonSFTPU: ""
      , directorioSFTPU: ""
      , enableSFTPD: false
      , urlBuzonSFTPD: ""
      , usuarioBuzonSFTPD: ""
      , passwordBuzonSFTPD: ""
      , puertoBuzonSFTPD: ""
      , directorioSFTPD: ""
      , enableZIP: false
      , passwordZIP: ""
      , enableMail: false
      , enableMailBases: false
      , numeroIntentos: 0
      , maxFileSize: 0
      , maxFileSizeZip: 0
      , geoPais: ""
      , geoPaisCompleto: ""
      , geoRelevanciaBuena: 0
      , geoRelevanciaRegular: 0
      , geoRelevanciaMala: 0
      , geocodeMapbox: false
      , geocodeGoogle: false
      , geocodeGoogleRelMala: false
      , geocodeGoogleRelRegular: false
      , geocodeGoogleRelBuena: false
      , geocodeGoogleImportarBases: false
      , version: 0
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , enableSFTPU: (enableSFTPU) => enableSFTPU
      , urlBuzonSFTPU: (urlBuzonSFTPU) => urlBuzonSFTPU
      , usuarioBuzonSFTPU: (usuarioBuzonSFTPU) => usuarioBuzonSFTPU
      , passwordBuzonSFTPU: (passwordBuzonSFTPU) => passwordBuzonSFTPU
      , puertoBuzonSFTPU: (puertoBuzonSFTPU) => puertoBuzonSFTPU
      , directorioSFTPU: (directorioSFTPU) => directorioSFTPU
      , enableSFTPD: (enableSFTPD) => enableSFTPD
      , urlBuzonSFTPD: (urlBuzonSFTPD) => urlBuzonSFTPD
      , usuarioBuzonSFTPD: (usuarioBuzonSFTPD) => usuarioBuzonSFTPD
      , passwordBuzonSFTPD: (passwordBuzonSFTPD) => passwordBuzonSFTPD
      , puertoBuzonSFTPD: (puertoBuzonSFTPD) => puertoBuzonSFTPD
      , directorioSFTPD: (directorioSFTPD) => directorioSFTPD
      , enableZIP: (enableZIP) => enableZIP
      , passwordZIP: (passwordZIP) => passwordZIP
      , enableMail: (enableMail) => enableMail
      , enableMailBases: (enableMailBases) => enableMailBases
      , numeroIntentos: (numeroIntentos) => numeroIntentos
      , maxFileSize: (maxFileSize) => maxFileSize
      , maxFileSizeZip: (maxFileSizeZip) => maxFileSizeZip
      , geoPais: (geoPais) => geoPais
      , geoPaisCompleto: (geoPaisCompleto) => geoPaisCompleto
      , geoRelevanciaBuena: (geoRelevanciaBuena) => geoRelevanciaBuena
      , geoRelevanciaRegular: (geoRelevanciaRegular) => geoRelevanciaRegular
      , geoRelevanciaMala: (geoRelevanciaMala) => geoRelevanciaMala
      , geocodeMapbox: (geocodeMapbox) => geocodeMapbox
      , geocodeGoogle: (geocodeGoogle) => geocodeGoogle
      , geocodeGoogleRelMala: (geocodeGoogleRelMala) => geocodeGoogleRelMala
      , geocodeGoogleRelRegular: (geocodeGoogleRelRegular) => geocodeGoogleRelRegular
      , geocodeGoogleRelBuena: (geocodeGoogleRelBuena) => geocodeGoogleRelBuena
      , geocodeGoogleImportarBases: (geocodeGoogleImportarBases) => geocodeGoogleImportarBases
      , version: (version) => version
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/generales/parametros.js